import { wrapper } from './AFormItem'

export const createItem = Component => (props) => wrapper(Component, props)
